import { useEffect, useRef } from 'react';
import { useInView, IntersectionOptions } from 'react-intersection-observer';

const useIntersectionObserver = (options = {} as IntersectionOptions) => {
  const [inViewRef, inView] = useInView({
    skip: false,
    threshold: 0,
    ...options
  });

  const scrollAreaRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    inViewRef(scrollAreaRef.current);
  }, [scrollAreaRef.current]);

  return [scrollAreaRef, inView] as const;
};

export default useIntersectionObserver;
